import React from 'react';

type Props = {
	vertical?: number;
	horizontal?: number;
};

const Spacer: React.FC<Props> = ({ vertical, horizontal }) => (
	<span
		style={{
			...vertical ? {
				display: 'block',
				paddingBottom: `${vertical}px`,
			} : {},
			...horizontal ? {
				display: 'inline',
				paddingRight: `${horizontal}px`,
			} : {},
		}}
	/>
);

export default Spacer;
